var map = {
	"./acimut.gif": "bcf6",
	"./caratula.jpg": "8f73",
	"./consumo.jpg": "24f6",
	"./contratapa.jpg": "d556",
	"./inclinacion.gif": "0f8b",
	"./inclinacion.jpg": "cff5",
	"./logo-energias-renovables.png": "02f5",
	"./logo-ministerio-de-energia.png": "cbff",
	"./orientacion.jpg": "5d96",
	"./panoramica.jpg": "412e",
	"./secretaria-de-energia.png": "434e",
	"./tarifa.png": "6949"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";